import React from 'react';

export const AccessDenied: React.FC = () => {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%' }}>
            <h3>Access Denied.</h3>
        </div>
    );
};
